import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import Services from "@/pages/services/page";
import Sermons from "@/pages/sermons/page";
import Live from "@/pages/live/page";
import Give from "@/pages/give/page";
import Events from "@/pages/events/page";
import Highlights from "@/pages/highlights/page";
import Pureheart from "@/pages/pureheart/page";
import Contact from "@/pages/contact/page";
import Testimonials from "@/pages/testimonials/page";
import News from "@/pages/news/page";
import AdminLogin from "@/pages/admin/login/page";
import AdminLayout from "@/pages/admin/AdminLayout";
import DashboardOverview from "@/pages/admin/dashboard/page";
import SiteSettingsPage from "@/pages/admin/settings/page";
import LeadersPage from "@/pages/admin/leaders/page";
import SermonsPage from "@/pages/admin/sermons/page";
import EventsPage from "@/pages/admin/events/page";
import NewsPage from "@/pages/admin/news/page";
import GalleryPage from "@/pages/admin/gallery/page";
import TestimonialsPage from "@/pages/admin/testimonials/page";
import MinistriesPage from "@/pages/admin/ministries/page";
import PureheartAdminPage from "@/pages/admin/pureheart/page";
import LiveStreamAdminPage from "@/pages/admin/live/page";
import InboxPage from "@/pages/admin/inbox/page";
import UsersPage from "@/pages/admin/users/page";
import ForgotPasswordPage from "@/pages/admin/forgot-password/page";
import ResetPasswordPage from "@/pages/admin/reset-password/page";
import TestEmailPage from "@/pages/admin/test-email/page";
import PrivacyPage from "@/pages/privacy/page";
import TermsPage from "@/pages/terms/page";
import CustomPage from "@/pages/custom/page";
import PagesAdminPage from "@/pages/admin/pages/page";
import Books from "@/pages/books/page";
import BooksAdminPage from "@/pages/admin/books/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/sermons",
    element: <Sermons />,
  },
  {
    path: "/live",
    element: <Live />,
  },
  {
    path: "/give",
    element: <Give />,
  },
  {
    path: "/events",
    element: <Events />,
  },
  {
    path: "/highlights",
    element: <Highlights />,
  },
  {
    path: "/pureheart",
    element: <Pureheart />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/testimonials",
    element: <Testimonials />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/page/:slug",
    element: <CustomPage />,
  },
  {
    path: "/books",
    element: <Books />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/admin/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <DashboardOverview /> },
      { path: "settings", element: <SiteSettingsPage /> },
      { path: "pages", element: <PagesAdminPage /> },
      { path: "books", element: <BooksAdminPage /> },
      { path: "leaders", element: <LeadersPage /> },
      { path: "sermons", element: <SermonsPage /> },
      { path: "events", element: <EventsPage /> },
      { path: "news", element: <NewsPage /> },
      { path: "gallery", element: <GalleryPage /> },
      { path: "testimonials", element: <TestimonialsPage /> },
      { path: "ministries", element: <MinistriesPage /> },
      { path: "pureheart", element: <PureheartAdminPage /> },
      { path: "live", element: <LiveStreamAdminPage /> },
      { path: "inbox", element: <InboxPage /> },
      { path: "users", element: <UsersPage /> },
      { path: "test-email", element: <TestEmailPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;